<template>
    <CompassSegmentedControl
        :modelValue="activeFilter[0]"
        :options="options"
        @update:modelValue="handleChange"
    />
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { Translator } from 'types/injects/translator.type';

interface Option {
    value: string;
    label: string;
}

interface Props {
    activeFilter: string[];
}

defineProps<Props>();

const emit = defineEmits(['filterUpdate']);

const $t = inject('$t') as Translator;

const options: Option[] = [
    { value: 'all', label: $t.__('timeline.TimelineEmailFilters.all') },
    { value: 'emailengine.received', label: $t.__('timeline.TimelineEmailFilters.received') },
    { value: 'emailengine.sent', label: $t.__('timeline.TimelineEmailFilters.sended') },
];

const handleChange = (value: string): void => {
    if (value !== '') {
        emit('filterUpdate', [value]);
    }
};
</script>
